import settings from 'settings'
import { getAnonymousId, getUser } from './auth'

const analytics = {
  page: (pageName, properties) => {
    getUser().then((user) => {
      window.analytics.page(pageName, {
        userId: user.username,
        properties: {
          ...properties,
          loggedIn: true,
        },
      })
    }).catch(() => {
      window.analytics.page(pageName, {
        anonymousId: getAnonymousId(),
        properties: {
          ...properties,
          loggedIn: false,
        },
      })
    })
  },
  track: (pageName, properties) => {
    getUser().then((user) => {
      window.analytics.track(pageName, {
        userId: user.username,
        properties: {
          ...properties,
        },
      })
    }).catch(() => {
      window.analytics.track(pageName, {
        anonymousId: getAnonymousId(),
        properties: {
          ...properties,
        },
      })
    })
  },
  beacon: (startedAt, receivedAt, refreshedAt, leftAt, failedAt, resetSandboxAt, contentUUID, sandboxUUID) => {
    if (navigator.sendBeacon && startedAt && typeof contentUUID === 'string') {
      navigator.sendBeacon(`${settings.urls.hacker}/analytics`, JSON.stringify({
        startedAt,
        receivedAt,
        refreshedAt,
        leftAt,
        failedAt,
        resetSandboxAt,
        contentUUID,
        sandboxUUID,
      }))
    }
    window.onunload = () => {

    }
  },
}

export default analytics
